import "@/global.css";
import { useAuth } from "@/src/contexts/auth.context";
import { Redirect } from "expo-router";
import { ActivityIndicator, View } from "react-native";

export default function App() {
  const { isLoading, isAuthenticated } = useAuth();

  if (isLoading) {
    return (
      <View className="flex-1 items-center justify-center">
        <ActivityIndicator size="large" />
      </View>
    );
  }

  if (!isAuthenticated) {
    return <Redirect href="/login" />;
  }

  // Authenticated: the AuthProvider is the single authority for where to land
  // (first-time profile setup → org selection → home), and it redirects via an
  // effect that always runs after this screen. Redirecting to a tab here too
  // would briefly mount that tab (e.g. dashboard) before the AuthProvider's
  // redirect replaces it — the "dashboard blink" before org selection. So we
  // just hold a spinner and let the AuthProvider route.
  return (
    <View className="flex-1 items-center justify-center">
      <ActivityIndicator size="large" />
    </View>
  );
}
